import _ from 'lodash';
import moment from 'moment/moment';
import * as actionTypes from './constants';

import { offerAdapter } from '../../../Utils/adapters/offer/offerAdapter';
import {
  calculateEntryStockResult,
  calculateMinimValuePricing,
  calculatePricingResult,
  calculatePrixEt,
  calculateTradeIn,
  extractCountry,
  extractEntryDateRelease,
  extractIdentification,
  extractRegistrationPlate,
  extractVehData,
  extractVin,
  generateEntryStockOption,
} from '../../helpers/pricing';
import { tradeAdapter } from '../../../Utils/adapters/autobizTrade/tradeAdapter';
import { decodeVinCountry } from '../../../config';

const fetchRecordRequest = () => ({
  type: actionTypes.FETCH_RECORD_REQUEST,
});

const fetchRecordSuccess = (recordId, record) => ({
  type: actionTypes.FETCH_RECORD_SUCCESS,
  payload: record,
  id: recordId,
});

const updateRecordSuccess = (recordId, record) => ({
  type: actionTypes.UPDATE_RECORD_SUCCESS,
  payload: record,
  id: recordId,
});

const fetchRecordFailure = (error) => ({
  type: actionTypes.FETCH_RECORD_FAILURE,
  payload: error,
});

export const putInitRecord = (record) => ({
  type: actionTypes.PUT_INIT_RECORD,
  payload: record,
});

const openRecord = (recordId) => ({
  type: actionTypes.OPEN_RECORD,
  payload: { recordId },
});

export const cleanStore = (newRecords) => ({
  type: actionTypes.CLEAN_STORE,
  payload: newRecords,
});

const getCurrentRecord = (state) => state.reduxRecords.currentRecord;

const fetchOfferRequest = () => ({
  type: actionTypes.FETCH_OFFER_REQUEST,
});

const fetchOfferSuccess = (recordId, offer) => ({
  type: actionTypes.FETCH_OFFER_SUCCESS,
  payload: offer,
  id: recordId,
});

const fetchOfferFailure = (error) => ({
  type: actionTypes.FETCH_OFFER_FAILURE,
  payload: error,
});

const postOfferRequest = () => ({
  type: actionTypes.POST_OFFER_REQUEST,
});

const postTradeSuccess = () => ({
  type: actionTypes.POST_OFFER_SUCCESS,
});

const postOfferFailure = (error) => ({
  type: actionTypes.POST_OFFER_FAILURE,
  payload: error,
});

const updateOfferRequest = () => ({
  type: actionTypes.UPDATE_OFFER_REQUEST,
});

const updateOfferSuccess = () => ({
  type: actionTypes.UPDATE_OFFER_SUCCESS,
});

const updateOfferFailure = (error) => ({
  type: actionTypes.UPDATE_OFFER_FAILURE,
  payload: error,
});

const postPartnerRequest = () => ({
  type: actionTypes.POST_PARTNER_REQUEST,
});

const putPartnerRequest = () => ({
  type: actionTypes.PUT_PARTNER_REQUEST,
});

// Pricing
const fetchPricingSuccess = (recordId, quotation) => ({
  type: actionTypes.FETCH_PRICING,
  payload: quotation,
  id: recordId,
});

const fetchVehicleVersionsSuccess = (recordId, versions) => ({
  type: actionTypes.FETCH_VEHICLE_VERSIONS,
  payload: versions,
  id: recordId,
});

const saveUserPricing = (recordId, params) => ({
  type: actionTypes.SAVE_USER_PRICING,
  payload: params,
  id: recordId,
});

const postPricingRequest = () => ({
  type: actionTypes.POST_PRICING_REQUEST,
});

const postPricingFailure = (error) => ({
  type: actionTypes.POST_PRICING_FAILURE,
  payload: error,
});

const fetchPreferencesSuccess = (recordId, preferences) => ({
  type: actionTypes.FETCH_PREFERENCES_SUCCESS,
  payload: preferences,
  id: recordId,
});

const fetchQuotationSuccess = (recordId, quotation) => ({
  type: actionTypes.FETCH_QUOTATION_SUCCESS,
  payload: quotation,
  id: recordId,
});

const currentTab = (tab) => ({
  type: actionTypes.CURRENT_TAB,
  payload: tab,
});

const fetchPricingHistorySuccess = (recordId, history) => ({
  type: actionTypes.FETCH_PRICINGHISTORY_SUCCESS,
  payload: history,
  id: recordId,
});

const fetchPricingHistoryFailure = (error) => ({
  type: actionTypes.FETCH_PRICINGHISTORY_FAILURE,
  payload: error,
});
const postCoverageFordRequest = () => ({
  type: actionTypes.POST_COVERAGEFORD_REQUEST,
});

const postCoverageFordSuccess = () => ({
  type: actionTypes.POST_COVERAGEFORD_SUCCESS,
});

const setOffersSales = (recordId, { offers }) => ({
  type: actionTypes.SET_OFFERS_SALES,
  payload: { offers },
  id: recordId,
});

const getSale = (recordId, { tradeRedux }) => ({
  type: actionTypes.GET_TRADE,
  payload: { tradeRedux },
  id: recordId,
});

const reinitialiseOfferAtSuccess = (offers) => ({
  type: actionTypes.REINITIALISE_OFFERAT_SUCCESS,
  payload: offers,
});

const setEntryStockOption = (recordId, options) => ({
  type: actionTypes.SET_ENTRY_STOCK_OPTION,
  payload: options,
  id: recordId,
});

/* const setRecordConfigForm = (recordId, configForm) => ({
  type: actionTypes.SET_RECORD_CONFIG_FORM,
  payload: configForm,
  id: recordId,
}); */

const fetchSourceInfo = (recordId, source) => ({
  type: actionTypes.FETCH_SOURCE_INFO,
  payload: source,
  id: recordId,
});

const fetchExternalRefRequest = () => ({
  type: actionTypes.FETCH_EXTERNAL_REF_REQUEST,
});

const postCounterOfferRequest = () => ({
  type: actionTypes.POST_COUNTER_OFFER_REQUEST,
});

const putCounterOfferRequest = () => ({
  type: actionTypes.PUT_COUNTER_OFFER_REQUEST,
});

const postPurchaseRequest = () => ({
  type: actionTypes.POST_PURCHASE_ORDER_REQUEST,
});

const postPurchaseFailure = (error) => ({
  type: actionTypes.POST_PURCHASE_ORDER_FAILURE,
  payload: error,
});

const postPurchaseSucess = () => ({
  type: actionTypes.POST_PURCHASE_ORDER_SUCCESS,
});
const fetchBuyers = (recordId, buyers) => ({
  type: actionTypes.FETCH_Buyers_INFO,
  payload: buyers,
  id: recordId,
});

const postPickupSites = () => ({
  type: actionTypes.POST_PICKUP_SITES,
});

export class RecordActions {
  constructor({ recordManager, auth, recordHandler }) {
    this.recordManager = recordManager;
    this.auth = auth;
    this.recordHandler = recordHandler;
  }

  getOffersApi =
    ({ type, setloadingStatus, setErrorStatus }) =>
    async (dispatch, getState) => {
      setloadingStatus(true);
      const recordId = getCurrentRecord(getState());
      try {
        const result = await this.recordHandler.getOffer(recordId, type);
        let offers = [];
        if (result.length > 0) offers = result;
        dispatch(setOffersSales(recordId, { offers }));
      } catch (error) {
        setErrorStatus(error.message);
      }
      setloadingStatus(false);
    };

  getSale = () => async (dispatch, getState) => {
    const recordId = getCurrentRecord(getState());
    const resTrade = await this.recordHandler.getSale('stock', recordId);
    if (resTrade.id) {
      const tradeRedux = await tradeAdapter(resTrade);
      dispatch(getSale(recordId, { tradeRedux }));
    }
  };

  cancelAppointment = () => async (dispatch, getState) => {
    const recordId = getCurrentRecord(getState());
    dispatch(fetchRecordRequest());
    try {
      await this.recordManager.updateRecordStatus(recordId, 'appointment-canceled');
      const record = await this.recordManager.getRecordFromApi(recordId);
      dispatch(updateRecordSuccess(recordId, record));
    } catch (error) {
      dispatch(fetchRecordFailure(error.message));
    }
  };

  reactivateRecord = () => async (dispatch, getState) => {
    const recordId = getCurrentRecord(getState());
    const state = getState();
    const formId = state.reduxRecords.data[recordId]?.record?.formId;
    dispatch(fetchRecordRequest());
    try {
      await this.recordManager.updateRecordStatus(recordId, (formId && 'expertise-started') || 'expertise-restarted');
      await dispatch(this.openRecord(recordId));
    } catch (error) {
      dispatch(fetchRecordFailure(error.message));
    }
  };

  launchInspection(callback, profile) {
    return async (dispatch, getState) => {
      const recordId = getCurrentRecord(getState());
      dispatch(fetchRecordRequest());
      try {
        const formId = await this.recordManager.launchInspection(recordId, profile);
        await dispatch(this.openRecord(recordId));
        await callback(formId);
      } catch (error) {
        dispatch(fetchRecordFailure(error.message));
      }
    };
  }

  createRecord = (callback) => {
    return async (dispatch, getState) => {
      dispatch(fetchRecordRequest());
      const state = getState();
      const record = state.reduxRecords.data[0];
      const data = {
        appointmentDateTime: record.appointment.appointmentDateTime,
        concessionId: record.carcheckPointOfSale.id,
        refHexaId: record.record.refHexaId,
        recordTypeId: record.record.recordTypeId,
        origin: record.record.origin,
        brandFileId: record.record.brandFileId,
        gdprClientInformed: record.record.gdprClientInformed,
        pdfLanguage: record.record.pdfLanguage,
      };
      try {
        const recordId = await this.recordManager.createRecord(data);
        await dispatch(this.openRecord(recordId));
        callback(recordId);
      } catch (error) {
        dispatch(fetchRecordFailure(error.message));
      }
    };
  };

  updateAppointment({ appointmentDateTime, concessionId }) {
    return async (dispatch, getState) => {
      const recordId = getCurrentRecord(getState());
      dispatch(fetchRecordRequest());
      try {
        await this.recordManager.updateAppointment(recordId, { appointmentDateTime, concessionId });
        const record = await this.recordManager.getRecordFromApi(recordId);
        dispatch(updateRecordSuccess(recordId, record));
      } catch (error) {
        dispatch(fetchRecordFailure(error.message));
      }
    };
  }

  updateAppointmentLocally = (record) => async (dispatch, getState) => {
    const recordId = getCurrentRecord(getState());
    dispatch(updateRecordSuccess(recordId, record));
  };

  openRecord = (recordId) => async (dispatch, getState) => {
    dispatch(fetchRecordRequest());
    try {
      const state = getState();
      let record = state.reduxRecords.data[recordId];
      if (!record) {
        if (navigator?.serviceWorker?.controller) {
          navigator.serviceWorker.controller.postMessage('clearCacheReport');
        }
        record = await this.recordManager.openRecord(recordId);
        dispatch(fetchRecordSuccess(recordId, record));
      } else {
        const formId = record.record?.formId;
        if (formId) await this.recordManager.saveTempForm(formId);
        dispatch(updateRecordSuccess(recordId, record));
      }
      dispatch(openRecord(recordId));
      dispatch(this.checkUpdateRecord(recordId, record));
    } catch (error) {
      dispatch(fetchRecordFailure(error.message));
    }
  };

  checkUpdateRecord = (recordId, record) => async (dispatch) => {
    if (await this.recordManager.remoteIsNewer(recordId, record.record?.updateAt?.date))
      dispatch(this.updateRecord(recordId));
  };

  updateRecord = (recordId) => async (dispatch) => {
    const record = await this.recordManager.getRecordFromApi(recordId);
    dispatch(updateRecordSuccess(recordId, record));
    const vehicleId = record?.record?.autobizTradeUuid || null;
    if (vehicleId !== null) dispatch(this.getSale(vehicleId));
  };

  refreshIfNecessary = () => async (dispatch, getState) => {
    const state = getState();
    const recordId = getCurrentRecord(state);
    const record = state.reduxRecords.data[recordId];
    if (record && recordId > 0) dispatch(this.checkUpdateRecord(recordId, record));
  };

  // offers
  fetchCoverageOffers = (recordId) => async (dispatch) => {
    let offers;
    dispatch(fetchOfferRequest());
    try {
      const offer = await this.recordHandler.getOffer(recordId, 'cover');
      const partners = await this.recordHandler.getPartnerOffer(recordId);
      offers = await offerAdapter(offer, partners);
      dispatch(fetchOfferSuccess(recordId, offers));
    } catch (error) {
      dispatch(fetchOfferFailure(error.message));
    }
  };

  fetchStockOffers = (recordId) => async (dispatch) => {
    dispatch(fetchOfferRequest());
    try {
      const offers = await this.recordHandler.getOffer(recordId, 'stock');
      dispatch(setOffersSales(recordId, { offers }));
      dispatch(fetchOfferSuccess(recordId, offers));
    } catch (error) {
      dispatch(fetchOfferFailure(error.message));
    }
  };

  postOffer = (recordId, body) => async (dispatch) => {
    dispatch(postOfferRequest());
    try {
      const data = await this.recordHandler.postTrade(recordId, body);
      dispatch(postTradeSuccess());
      return data;
    } catch (error) {
      dispatch(postOfferFailure(error.message));
      return null;
    }
  };

  postAnnonceAt = (body) => async (dispatch) => {
    dispatch(updateOfferRequest());
    try {
      await this.recordHandler.postAnnonceAt(body);
      dispatch(updateOfferSuccess());
    } catch (error) {
      dispatch(updateOfferFailure(error.message));
    }
  };

  postAnnonceAtTrade = (body) => async (dispatch, getState) => {
    dispatch(updateOfferRequest());
    try {
      const state = getState();
      const recordId = state.reduxRecords.currentRecord;
      await this.recordHandler.postAnnonceAt(body);
      dispatch(this.updateRecord(recordId));
      dispatch(reinitialiseOfferAtSuccess([]));
    } catch (error) {
      dispatch(updateOfferFailure(error.message));
    }
  };

  postPartnerRequest = (partner, comment, vehicleId) => async (dispatch, getState) => {
    const state = getState();
    const recordId = state.reduxRecords.currentRecord;
    dispatch(postPartnerRequest());
    try {
      await this.recordHandler.postPartner(partner, comment, vehicleId);
    } catch (error) {
      // dispatch(fetchOfferFailure(error.message));
    } finally {
      dispatch(this.fetchCoverageOffers(recordId));
    }
  };

  putPartnerRequest = (partnerOfferId, is_accepted) => async (dispatch, getState) => {
    const state = getState();
    const recordId = state.reduxRecords.currentRecord;
    dispatch(putPartnerRequest());
    try {
      await this.recordHandler.putPartnerOffer(partnerOfferId, is_accepted);
    } catch (error) {
      // dispatch(fetchOfferFailure(error.message));
    } finally {
      dispatch(this.fetchCoverageOffers(recordId));
    }
  };

  fetchPickupSites = () => async () => {
    const pickupInfos = await this.recordHandler.getPickupSites();
    return pickupInfos;
  };

  postPickupSites =
    (withdrawalSiteId, withdrawalSiteName, billingSite, auctionGroupId, idPartnerOffer) => async (dispatch) => {
      dispatch(postPickupSites());
      try {
        await this.recordHandler.postPickupSites(
          withdrawalSiteId,
          withdrawalSiteName,
          billingSite,
          auctionGroupId,
          idPartnerOffer,
        );
      } catch (e) {
        console.error(e.message);
      }
    };

  fetchPricing =
    (recordId, planedDelay, userValue, refurbishingCosts, currentVersion = null, type = 'pricing') =>
    async (dispatch, getState) => {
      dispatch(fetchRecordRequest());
      try {
        const state = getState();
        const record = this.getRecordDetails(recordId, state);
        const { country, carcheckRefurbishingCosts, mileage } = extractVehData(record);
        let preferences = record?.preferences;
        if (!preferences) preferences = await dispatch(this.fetchPreference(recordId));
        let quotation = record?.quotation;
        if (!quotation) quotation = await dispatch(this.fetchQuotation(currentVersion));
        let entryStockKey = 0;
        let entryStockDate = null;
        if (type === 'pricing') {
          entryStockKey = record?.userPricing?.entryStockKey;
        } else {
          entryStockKey = state.reduxRecords.data[recordId]?.supervisor?.entryStockValue;
          entryStockDate = state.reduxRecords.data[recordId]?.supervisor?.entryStockDate?.date;
        }

        const tradeInParams = { country, preferences };
        const b2cMarketValueCorrected =
          (quotation._quotation.b2cMarketValue && quotation._quotation.b2cMarketValue) ||
          quotation._quotation.corrected;
        const marketValueAutobiz = calculateEntryStockResult(b2cMarketValueCorrected, entryStockKey);
        const tradeInAutobiz = calculateTradeIn({
          ...tradeInParams,
          planedDelay: (quotation._salesSpeed.rotation === 0 && 60) || quotation._salesSpeed.rotation,
          marketValue: marketValueAutobiz,
          refurbishingCosts: carcheckRefurbishingCosts,
        });

        let pricingAutobizResult = calculateEntryStockResult(
          calculatePricingResult(tradeInAutobiz, carcheckRefurbishingCosts),
          entryStockKey,
        );

        const sourceId = state.reduxRecords.data[recordId]?.record?.sourceId || null;
        pricingAutobizResult = calculateMinimValuePricing(sourceId, pricingAutobizResult);

        let prixEt = null;
        let tradeInUser = null;
        if (type === 'pricing') {
          tradeInUser = calculateTradeIn({
            ...tradeInParams,
            marketValue: userValue,
            refurbishingCosts,
            planedDelay,
          });
          const userPricingData = state.reduxRecords.data[recordId]?.userPricing;
          prixEt = calculatePrixEt(
            tradeInAutobiz,
            carcheckRefurbishingCosts,
            userPricingData && userPricingData.vatSpain,
            country,
          );
          const userPricing = {
            marketValue: b2cMarketValueCorrected,
            plannedDelay: (quotation._salesSpeed.rotation === 0 && 60) || quotation._salesSpeed.rotation,
            refurbishingCosts: carcheckRefurbishingCosts,
          };
          if (userPricingData && userPricingData.plannedDelay === undefined)
            dispatch(this.updateUserPricing(userPricing));
        } else {
          dispatch(
            this.putSupervisorInfos(recordId, {
              suggestedPrice: pricingAutobizResult,
              suggestedVersionId: currentVersion,
              suggestedMileage: mileage,
              suggestedEntryStockDate: entryStockDate,
            }),
          );
          const newRecord = await this.recordManager.getRecordFromApi(recordId);
          dispatch(updateRecordSuccess(recordId, newRecord));
        }

        dispatch(
          fetchPricingSuccess(recordId, {
            ...quotation,
            tradeInUser,
            tradeInAutobiz,
            marketValue: marketValueAutobiz,
            prixEt,
            pricingAutobizResult,
          }),
        );
      } catch (e) {
        dispatch(fetchRecordFailure(e.message));
      }
    };

  fetchPreference = () => async (dispatch, getState) => {
    const state = getState();
    const recordId = state.reduxRecords.currentRecord;
    const preferences = await this.recordHandler.getPreference();
    dispatch(fetchPreferencesSuccess(recordId, preferences));
    return preferences;
  };

  fetchQuotation =
    (currentVersion = null) =>
    async (dispatch, getState) => {
      const state = getState();
      const recordId = state.reduxRecords.currentRecord;
      const record = this.getRecordDetails(recordId, state);
      const { versions } = record;
      let quotation;
      let version = currentVersion;
      const { versionId, mileage, yearMec, monthMec } = extractVehData(record);
      if (!version) version = versionId;
      if (version && mileage && yearMec && monthMec)
        quotation = await this.recordHandler.getVersionDetails(version, yearMec, monthMec, mileage);
      else quotation = await this.recordHandler.getVersionDetails(versions?.[0]?.id, yearMec, monthMec, mileage);
      dispatch(fetchQuotationSuccess(recordId, quotation));
      return quotation;
    };

  updatePricingVehicle =
    ({ recordId, mileage, versionId, versionName, versionData, equipments }) =>
    async (dispatch, getState) => {
      dispatch(fetchRecordRequest());
      const state = getState();
      const vehicle = this.getRecordDetails(recordId, state)?.vehicle;
      try {
        if (vehicle.mileage !== mileage || vehicle.versionId !== versionId) {
          const RecordData = { mileage, versionId, versions: versionName };
          if (versionData) {
            RecordData.versionsData = JSON.stringify(versionData);
            RecordData.versionType = 'vin';
            RecordData.carEquipment = JSON.stringify(equipments);
          }
          await this.recordHandler.updateRecordData(recordId, RecordData);
          const record = await this.recordManager.getRecordFromApi(recordId);
          dispatch(updateRecordSuccess(recordId, record));
        }
        await dispatch(this.fetchQuotation(versionId));
      } catch (e) {
        dispatch(fetchRecordFailure(e.message));
      }
    };

  getVehicleVersions = (recordId) => async (dispatch, getState) => {
    const state = getState();
    const versions = this.getRecordDetails(recordId, state)?.vehicle?.versionsData;
    if (versions && Array.isArray(versions)) {
      dispatch(fetchVehicleVersionsSuccess(recordId, versions));
      return;
    }
    try {
      dispatch(fetchRecordRequest());
      const record = this.getRecordDetails(recordId, state);
      const language = record.record?.language;
      let versionsData = [];
      const country = extractCountry(record);
      const identificationType = extractIdentification(record);
      if (country === 'NL') {
        versionsData = await dispatch(this.getAutotelexVersions(recordId));
      } else if (identificationType === 'manuel') {
        let { dateOfRelease } = extractVehData(record);
        const { makeId, modelId, fuelId, bodyId, doors, seats, gearId, engine, liter, entryDateOfRelease } =
          extractVehData(record);
        dateOfRelease = entryDateOfRelease || dateOfRelease;
        versionsData = await dispatch(
          this.getVersions({
            makeId,
            modelId,
            fuelId,
            bodyId,
            doors,
            seats,
            gearId,
            dateOfRelease,
            engine,
            country,
            liter,
          }),
        );
      } else if (decodeVinCountry.includes(country)) {
        const vin = extractVin(record);
        const entryDateOfRelease = extractEntryDateRelease(record);
        const registrationDate =
          entryDateOfRelease !== null ? moment(entryDateOfRelease.date).format('YYYY-MM-DD') : null;
        const { data } = await this.recordHandler.getVehiculeByVin(vin, country, registrationDate, language);
        versionsData = data.versions;
      } else {
        const registration = extractRegistrationPlate(record);
        const vin = extractVin(record);
        let data = {};
        if (!registration && vin) {
          const entryDateOfRelease = extractEntryDateRelease(record);
          const registrationDate =
            entryDateOfRelease !== null ? moment(entryDateOfRelease.date).format('YYYY-MM-DD') : null;
          data = (await this.recordHandler.getVehiculeByVin(vin, country, registrationDate, language)).data;
        } else data = (await this.recordHandler.getVehiculeByReg(registration, country, language)).data;
        versionsData = data.versions;
      }
      dispatch(fetchVehicleVersionsSuccess(recordId, versionsData));
    } catch (e) {
      dispatch(fetchRecordFailure(e.message));
    }
  };

  getRecordDetails = (recordId, state) => state.reduxRecords.data[recordId];

  updateUserPricing = (data) => async (dispatch, getState) => {
    const state = getState();
    const recordId = state.reduxRecords.currentRecord;
    const userPricing = this.getRecordDetails(recordId, state)?.userPricing || {};
    if (data?.pricingUserResult) {
      const sourceId = state.reduxRecords.data[recordId]?.record?.sourceId || null;
      _.set(data, 'pricingUserResult', calculateMinimValuePricing(sourceId, data.pricingUserResult));
    }
    dispatch(saveUserPricing(recordId, { ...userPricing, ...data }));
  };

  offerPricing = (recordId, data) => async (dispatch) => {
    dispatch(postPricingRequest());
    try {
      const id = await this.recordHandler.postPricing(recordId, data);
      if (id) {
        const record = await this.recordManager.getRecordFromApi(recordId);
        dispatch(updateRecordSuccess(recordId, record));
      }
      return id;
    } catch (e) {
      dispatch(postPricingFailure(e.message));
      return null;
    }
  };

  changeCurrentTab = (tab) => async (dispatch) => {
    dispatch(currentTab(tab));
  };

  getVersions = (filters) => async () => {
    let versions;
    try {
      versions = await this.recordHandler.getVersions(filters, 'versions');
      return versions;
    } catch {
      const listParam = ['liter', 'kw', 'fiscal', 'engine', 'gearId', 'seats', 'doors', 'fuelId', 'bodyId'];
      for (let i = 0; i <= listParam.length; i++) {
        if (filters[listParam[i]]) {
          const changeFilter = filters;
          delete changeFilter[listParam[i]];
          try {
            /* eslint-disable no-await-in-loop */
            versions = await this.recordHandler.getVersions(changeFilter, 'versions');
            return versions;
          } catch {
            // empty
          }
        }
      }
    }
    return null;
  };

  fetchPricingHistory = (recordId) => async (dispatch) => {
    dispatch(fetchRecordRequest());
    try {
      const history = await this.recordHandler.getPricingHistory(recordId, 2);
      dispatch(fetchPricingHistorySuccess(recordId, history));
      return history;
    } catch (e) {
      dispatch(fetchPricingHistoryFailure(e.message));
      return null;
    }
  };

  postFordCoverage = (recordId, data) => async (dispatch) => {
    dispatch(postCoverageFordRequest());
    const message = await this.recordHandler.postFordCoverage(recordId, data);
    dispatch(this.refreshIfNecessary());
    dispatch(postCoverageFordSuccess());
    return message;
  };

  fetchGroupUserInfos = () => async () => {
    const userInfos = await this.recordHandler.getGroupUserInfos();
    return userInfos;
  };

  updateRecordData = (recordId) => async (dispatch) => {
    const record = await this.recordManager.getRecordFromApi(recordId);
    dispatch(updateRecordSuccess(recordId, record));
    return record;
  };

  getSaleCoverage = (recordId) => async () => {
    const data = await this.recordHandler.getSale('cover', recordId);
    return data;
  };

  getEntryStockOption = (recordId) => async (dispatch, getState) => {
    const state = getState();
    const record = this.getRecordDetails(recordId, state);
    let entryStockOption = record?.entryStockOption;
    if (!entryStockOption) {
      entryStockOption = generateEntryStockOption([10, 11, 12, 13, 14].includes(record?.record?.originId));
      dispatch(setEntryStockOption(recordId, entryStockOption));
    }
  };

  putSupervisorInfos = (recordId, data) => async () => {
    await this.recordHandler.putSupervisorInfos(recordId, data);
  };

  getConfigurationsDetails = (id) => async () => {
    const res = await this.recordHandler.getConfigurationsDetails(id);
    return res;
  };

  /* getConfigForm = (recordId) => async (dispatch, getState) => {
    const state = getState();
    const configType = this.getRecordDetails(recordId, state)?.record?.configType;
    const originId = this.getRecordDetails(recordId, state)?.record?.originId;
    if (configType) return;
    if ([1, 11].includes(originId)) {
      dispatch(setRecordConfigForm(recordId, 'rad_form'));
    } else {
      const profile = this.getRecordDetails(recordId, state)?.record?.profile;
      const sourceInfo = this.getRecordDetails(recordId, state)?.sourceInfos;
      const configId = sourceInfo?.sourceGroupData?.[`${profile.toLowerCase()}Form`];
      const configForm = await dispatch(this.getConfigurationsDetails(configId));
      dispatch(setRecordConfigForm(recordId, configForm?.label));
    }
  }; */

  putSales = (saleId, data) => async () => {
    const res = await this.recordHandler.putSales(saleId, data);
    return res;
  };

  putOffer = (offerId, data) => async () => {
    return this.recordHandler.putOffer(offerId, data);
  };

  getSourceInfo = (recordId) => async (dispatch, getState) => {
    const state = getState();
    const sourceId = this.getRecordDetails(recordId, state)?.record?.sourceId;
    const countryId = this.getRecordDetails(recordId, state)?.record?.countryId;
    const originId = this.getRecordDetails(recordId, state)?.record?.originId;
    const sourceInfos = this.getRecordDetails(recordId, state)?.sourceInfos;
    if (sourceId && !sourceInfos) {
      let res = {};
      if ([10, 12, 13].includes(originId)) {
        const params = { countryId, recordId };
        res = await this.recordHandler.getSource(sourceId, params);
      } else {
        res = await this.recordHandler.getSource(sourceId);
      }
      dispatch(fetchSourceInfo(recordId, res));
    }
  };

  getBuyersBySource = (recordId, sourceId, countryId) => async (dispatch) => {
    const filter = JSON.stringify({ sourceId, countryId });
    const range = JSON.stringify([0, 999]);
    const sort = JSON.stringify(['firstName', 'ASC']);
    const res = await this.recordHandler.getBuyers({ filter, sort, range });
    if (res?.length) dispatch(fetchBuyers(recordId, res));
  };

  postBee2LinkRequest = (recordId, data) => {
    return async (dispatch) => {
      const res = await this.recordHandler.postBee2Link(recordId, data);
      const record = await this.recordManager.getRecordFromApi(recordId);
      dispatch(updateRecordSuccess(recordId, record));
      return res;
    };
  };

  lockPricing = (recordId) => async () => {
    const res = await this.recordHandler.lockPricing(recordId);
    return res;
  };

  unlockPricing = (recordId) => async () => {
    const res = await this.recordHandler.unlockPricing(recordId);
    return res;
  };

  postCounterInspection = (inspectionInitialRecordId, recordId) => async (dispatch) => {
    dispatch(fetchRecordRequest());
    await this.recordHandler.postCounterInspection(inspectionInitialRecordId, recordId);
    const record = await this.recordManager.getRecordFromApi(recordId);
    dispatch(updateRecordSuccess(recordId, record));
  };

  removeCounterInspection = (recordId) => async (dispatch) => {
    dispatch(fetchRecordRequest());
    await this.recordHandler.removeCounterInspection(recordId);
    const record = await this.recordManager.getRecordFromApi(recordId);
    dispatch(updateRecordSuccess(recordId, record));
  };

  updateStatus = (recordId, status) => async () => {
    const res = await this.recordHandler.updateStatus(recordId, status);
    return res;
  };

  createInspectionVersion = (recordId, data) => async () => {
    const res = await this.recordHandler.createInspectionVersion(recordId, data);
    return res;
  };

  updateRemoteRecord = (recordId, data) => async () => {
    const res = await this.recordHandler.updateRecordData(recordId, data);
    return res;
  };

  getExternalRef = (recordId) => async (dispatch) => {
    dispatch(fetchExternalRefRequest());
    const res = await this.recordHandler.getExternalRef(recordId);
    const record = await this.recordManager.getRecordFromApi(recordId);
    dispatch(updateRecordSuccess(recordId, record));
    return res.data;
  };

  postCounterOffer = (amount, offerId, userId, saleId, type) => async (dispatch, getState) => {
    const state = getState();
    const recordId = state.reduxRecords.currentRecord;
    dispatch(postCounterOfferRequest());
    try {
      await this.recordHandler.postCounterOffer(amount, offerId, userId, saleId);
    } catch (error) {
      // dispatch(fetchOfferFailure(error.message));
    } finally {
      if (type && type === 'stock') {
        dispatch(this.fetchStockOffers(recordId));
      } else {
        dispatch(this.fetchCoverageOffers(recordId));
      }
    }
  };

  putCounterOffer = (uuid, userId, accepted, type) => async (dispatch, getState) => {
    const state = getState();
    const recordId = state.reduxRecords.currentRecord;
    dispatch(putCounterOfferRequest());
    try {
      await this.recordHandler.putCounterOffer(uuid, userId, accepted);
    } catch (error) {
      // dispatch(fetchOfferFailure(error.message));
    } finally {
      if (type && type === 'stock') {
        dispatch(this.fetchStockOffers(recordId));
      } else {
        dispatch(this.fetchCoverageOffers(recordId));
      }
    }
  };

  generatePurchaseOrder = (saleId) => async (dispatch) => {
    dispatch(postPurchaseRequest());
    const res = await this.recordHandler.generatePurchaseOrder(saleId);
    if (res?.id) {
      dispatch(postPurchaseSucess());
    } else {
      dispatch(postPurchaseFailure());
    }
    return res;
  };

  postReportAi =
    (recordId, relatedRecordId = null) =>
    async (dispatch) => {
      dispatch(fetchRecordRequest());
      await this.recordHandler.postReportAi(recordId);
      const record = await this.recordManager.getRecordFromApi(relatedRecordId ?? recordId);
      dispatch(updateRecordSuccess(relatedRecordId ?? recordId, record));
    };

  retriveHistovecInfo = (recordId, data) => async () => {
    const res = await this.recordHandler.retriveHistovecInfo(recordId, data);
    return res;
  };

  requestGuaranteedPrice = (recordId) => async () => {
    const res = this.recordHandler.postGuaranteedPrice(recordId);
    return res;
  };

  getHistoryNrm =
    (nrmRecord, nrmHistoryTypeId = 1) =>
    async () => {
      const res = this.recordHandler.getHistoryNrm(nrmRecord, nrmHistoryTypeId);
      return res;
    };

  putNrmStatus = (recordId, nrmStatusId) => async () => {
    await this.recordHandler.putNrmStatus(recordId, nrmStatusId);
  };

  putMaintainedGuanranteed = (maintainedGuarantee, recordId) => async () => {
    await this.recordHandler.putMaintainedGuanranteed(maintainedGuarantee, recordId);
  };

  createCounterInspection = (recordId) => async () => {
    return this.recordHandler.createCounterInspection(recordId);
  };

  putNCOrderLink = (nrmRecordId, data) => async () => {
    return this.recordHandler.putNCOrderLink(nrmRecordId, data);
  };

  putFirmValuation = (recordId, data) => async () => {
    await this.recordHandler.putFirmValuation(recordId, data);
  };

  getAutotelex = (registration, data) => async (dispatch, getState) => {
    const state = getState();
    const recordId = state.reduxRecords.currentRecord;
    const res = await this.recordHandler.getAutotelex(registration, data);
    const parameters = {
      mileage: data.mileage,
      versionId: data.versionId,
      body: res,
    };
    await this.recordHandler.createExternalProvider(recordId, parameters);
    const { versions } = res;
    dispatch(fetchVehicleVersionsSuccess(recordId, versions));
    return res;
  };

  createExternalProvider = (recordId, data) => async () => {
    const json = localStorage.getItem('autotelex');
    const parameters = {
      mileage: data.mileage,
      versionId: data.versionId,
      body: JSON.parse(json),
    };
    const res = await this.recordHandler.createExternalProvider(recordId, parameters);
    if (res > 0) localStorage.removeItem('autotelex');
    return res;
  };

  getAutotelexVersions = (recordId) => async (dispatch, getState) => {
    const state = getState();
    const { mileage: expertiseMileage } = this.getRecordDetails(recordId, state)?.vehicleExpertise;
    const { registration, mileage: vehicleMileage, versionId } = this.getRecordDetails(recordId, state)?.vehicle;
    const mileage =
      expertiseMileage !== undefined && expertiseMileage !== null && expertiseMileage !== ''
        ? expertiseMileage
        : vehicleMileage;
    const res = await this.recordHandler.getAutotelexVersions(recordId, { mileage, versionId });
    if (res.length === 0) dispatch(this.getAutotelex(registration, { mileage, versionId }));
    return res;
  };

  getRemoteRecord = (recordId) => async (dispatch) => {
    dispatch(fetchRecordRequest());
    const record = await this.recordManager.getRecordFromApi(recordId);
    const formId = record?.record?.formId;
    if (formId && formId !== 0) await this.recordManager.saveForm(formId);
    dispatch(updateRecordSuccess(recordId, record));
  };

  getVehicleVersionsByVin = (recordId) => async (dispatch, getState) => {
    const state = getState();
    const record = this.getRecordDetails(recordId, state);
    const language = record.record?.language;
    const country = extractCountry(record);
    const entryDateOfRelease = extractEntryDateRelease(record);
    const registrationDate = entryDateOfRelease !== null ? moment(entryDateOfRelease.date).format('YYYY-MM-DD') : null;
    const vin = extractVin(record);
    const { data } = await this.recordHandler.getVehiculeByVin(vin, country, registrationDate, language, 'decodeVin');
    return data && data?.versions && data?.versions?.length > 0 ? data : null;
  };

  refuseAllOffers = (recordId, saleId) => async (dispatch) => {
    dispatch(fetchRecordRequest());
    const res = await this.recordHandler.refuseOffersBySale(saleId);
    const record = await this.recordManager.getRecordFromApi(recordId);
    dispatch(updateRecordSuccess(recordId, record));
    return res;
  };

  getPackageMonkGenerate(recordId) {
    return this.recordHandler.getPackageMonkGenerate(recordId);
  }
}
